var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMasterTechnicalSkills(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_14",
    "data-name": "Group 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 84.216,
    height: 84.95,
    viewBox: "0 0 84.216 84.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e68242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dd4633"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    width: 84.216,
    height: 84.95,
    fill: "url(#linear-gradient)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M120.109,261.342c11.906-.89,22.046,9.827,20.037,21.736a5.063,5.063,0,0,1-4.455,3.868H107.313a5.049,5.049,0,0,1-4.481-4.013,18.945,18.945,0,0,1,17.277-21.592",
    transform: "translate(-79.357 -201.997)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M152.452,169.909c12.989-1.475,14.491,17.919,2.159,18.975-12.6,1.079-14.114-17.617-2.159-18.975",
    transform: "translate(-111.533 -131.29)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M268.6,285.817a20.8,20.8,0,0,0-3.359-9.428,14.078,14.078,0,0,1,22.18,1.562c1.8,2.727,3.406,6.666-.917,7.852Z",
    transform: "translate(-205.055 -210.047)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M21,285.817l-17.9-.013c-4.324-1.187-2.718-5.125-.917-7.852a14.078,14.078,0,0,1,22.18-1.562A20.633,20.633,0,0,0,21,285.817",
    transform: "translate(-0.255 -210.047)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M144.542,50.165a.685.685,0,0,1,.574.061c.573.356,2.344,6.766,3.15,7.722.472.329,5.549.27,6.61.354.834.066,2.629.17,1.6,1.258L150.4,64.538l2.007,7.8a.7.7,0,0,1-.453.724c-.641.158-6.125-4.331-7.112-4.4-.809-.055-5.759,3.8-6.877,4.333-.359.212-.676-.05-.815-.38l1.988-8.077c-.72-1.153-6.131-4.554-6.365-5.384-.113-.4.167-.589.541-.675,2.383-.543,5.543.033,7.96-.532.718-.87,2.7-7.6,3.266-7.782",
    transform: "translate(-102.626 -38.753)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M285.681,200.567c5.986-.863,10.48,4.937,7.66,10.378-3.606,6.958-14.6,3.656-13.318-4.656a7.338,7.338,0,0,1,5.658-5.722",
    transform: "translate(-216.398 -154.987)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M34.877,200.539c10.675-1.447,10.99,14.4,1.172,14.212-8.785-.167-9.307-13.109-1.172-14.212",
    transform: "translate(-22.498 -154.959)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M223.59,31.476a1.362,1.362,0,0,1,1.485,2.164l-5.109,4.573a1.363,1.363,0,0,1-2.062-1.548c.238-.926,4.381-3.84,5.141-4.885a1.258,1.258,0,0,1,.545-.3",
    transform: "translate(-168.414 -24.293)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M121.346,31.433a1.668,1.668,0,0,1,1.4.228c1.307,1.518,3.593,2.863,4.836,4.337a1.373,1.373,0,0,1-1.665,2.173l-4.955-4.386a1.455,1.455,0,0,1,.383-2.351",
    transform: "translate(-93.179 -24.251)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M180.369.046a1.343,1.343,0,0,1,1.749,1.237,34.31,34.31,0,0,1-.04,5.4,1.371,1.371,0,0,1-2.685-.3,33.589,33.589,0,0,1,.014-5.259,1.309,1.309,0,0,1,.963-1.081",
    transform: "translate(-138.609 0)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterTechnicalSkills);
export default __webpack_public_path__ + "static/media/master_technical_skills.2d3805f69398fe3b356ce870d57e4357.svg";
export { ForwardRef as ReactComponent };